import { ModalBody } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

export const StyledModalBody = styled(ModalBody)`
  position: relative;
`;
